import { DownloadOutlined } from '@ant-design/icons';
import { App as AntApp, Button } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { apiDownload } from '../../lib/api-client';

type Props = {
  path: string;
  params: URLSearchParams;
  fileBaseName: string;
};

export const ExportCsvButton = ({ path, params, fileBaseName }: Props) => {
  const { message } = AntApp.useApp();
  const [exporting, setExporting] = useState(false);

  const exportCsv = async () => {
    const query = new URLSearchParams(params);
    query.set('tz', Intl.DateTimeFormat().resolvedOptions().timeZone);
    setExporting(true);
    try {
      await apiDownload(`${path}?${query.toString()}`, `${fileBaseName}-${dayjs().format('YYYY-MM-DD')}.csv`);
    } catch (error) {
      message.error(error instanceof Error ? error.message : 'Export failed');
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button icon={<DownloadOutlined />} loading={exporting} onClick={exportCsv}>
      Export CSV
    </Button>
  );
};
